import useIsMobile from "../../hooks/useIsMobile";

import { VideoElement } from "../Video";
import { ImageElement } from "../Image";
import { LocalizedLink } from "../link/localizedLink";
import { Solution } from "../../../sanity/lib/types/solutions";

export const SolutionPreview = ({
    solution,
    isListLayout,
}: {
    solution: Solution;
    isListLayout?: boolean;
}) => {
    const { isMobile } = useIsMobile();

    const label = (
        <div>
            {solution.previewImage?.asset?.[0]._type === "image" ? (
                <ImageElement
                    width={2560}
                    src={solution.previewImage?.asset[0]}
                    alt={solution.previewImage.alt || ""}
                    className="md:w-full object-cover aspect-[453/567] md:aspect-[453/567]"
                />
            ) : (
                <VideoElement
                    src={solution.previewImage?.asset?.[0].assetUrl?.url || ""}
                    aria-label={solution.previewImage?.alt || ""}
                    className="md:w-full object-cover aspect-[453/567] md:aspect-[453/567]"
                    useIntersection={isMobile ? true : false}
                />
            )}
            {(isListLayout || !isMobile) && (
                <>
                    <h3 className="mt-3 md:mt-4 mb-1.5 d-headline-3">{solution.previewTitle}</h3>
                    <p className="pb-2 md:pb-0 d-body-m">
                        {solution.previewDescription || solution.industry?.title}
                    </p>
                </>
            )}
        </div>
    );

    return (
        <LocalizedLink
            slug={`solutions/${solution.metadata?.slug.current}`}
            key={solution._id}
            className={`md:col-span-2 solution-item ${isListLayout ? "col-span-6" : "col-span-3"}`}
            label={label}
        />
    );
};
